<!-- 顶部右侧控制栏 -->
<template>
  <div class="header-right_control">
    <!-- 用户头像 -->
    <div
      class="header-right_control_icon"
      :style="{ 'background-image': `url(${userInfo.avatar || defaultAvatar})` }"
    >
      <div class="header-right_control_wrap">
        <!-- 显示角色和昵称 -->
        <div class="header-right_control_wrap-head">
          <div class="header-right_control_wrap-head-left">
            <span class="header-right_control_wrap-head-left-role">
              {{ userInfo.role_name | roleFilter }}
            </span>
            <span class="header-right_control_wrap-head-left-name" v-if="!auth_gd">
              {{ userInfo.nickname }}
              <!--发起端，顶部导航 右侧头像区域 场景有使用-->
            </span>
          </div>
        </div>

        <div class="header-right_control_wrap-container">
          <!-- 媒体设置 -->
          <div
            class="header-right_control_wrap-container-setting"
            :class="{ 'header-right_control_wrap-container-disabled': thirtPushStreamimg }"
            v-if="showSetting"
            @click="openMediaSettings"
          >
            <i class="vh-iconfont vh-line-setting"></i>
            <p>{{ $t('setting.setting_1030') }}</p>
          </div>

          <div
            class="header-right_control_wrap-container-setting"
            :class="{
              'header-right_control_wrap-container-disabled':
                !isLiving || isInsertFilePushing || isCurrentShareScreen
            }"
            v-if="configList['is_interact'] && isSupportSplitScreen && !auth_gd"
            @click="handleSplitScreenChange"
          >
            <i class="vh-saas-iconfont vh-saas-a-line-Viewlayout"></i>
            <p>{{ isOpenSplitScreen ? $t('host.host_1015') : $t('host.host_1014') }}</p>
          </div>
          <div
            class="header-right_control_wrap-container-setting"
            v-if="userInfo.role_name != 1"
            @click="roleQuit"
          >
            <i class="vh-iconfont vh-line-exit"></i>
            <p>{{ $t('host.host_1016') }}</p>
          </div>

          <!-- 第三方发起 -->
          <div
            class="header-right_control_wrap-container-setting"
            v-if="isShowThirdPushStream && !thirtPushStreamimg && !isDirector"
            @click="thirdPartySwitch(true)"
          >
            <i class="vh-saas-iconfont vh-saas-a-line-thirdpartyinitiate"></i>
            <p>{{ $t('host.host_1017') }}</p>
          </div>

          <!-- 网页发起 -->
          <div
            class="header-right_control_wrap-container-setting"
            @click="thirdPartySwitch(false)"
            v-if="isShowThirdPushStream && thirtPushStreamimg"
          >
            <i class="vh-saas-iconfont vh-saas-a-color-webpageinitiate1"></i>
            <p>{{ $t('host.host_1018') }}</p>
          </div>

          <template v-if="!isEmbedLiveSream">
            <!-- 虚拟人数 -->
            <div
              class="header-right_control_wrap-container-setting"
              v-if="configList['virtual_user'] && webinarInfo.mode != 6 && !auth_gd"
              @click="openVirtualAudience"
            >
              <i class="vh-saas-iconfont vh-saas-a-line-dissolutiongrouping"></i>
              <p>{{ $t('host.host_1019') }}</p>
            </div>

            <!-- 点赞数据 -->
            <div
              class="header-right_control_wrap-container-setting"
              v-if="configList['virtual_user'] && webinarInfo.mode != 6 && !auth_gd"
              @click="openVirtualLikes"
            >
              <i class="vh-saas-iconfont vh-saas-line-thumbs"></i>
              <p>{{ $t('host.host_1020') }}</p>
            </div>
          </template>

          <!-- 信息修改 -->
          <div class="header-right_control_wrap-container-setting" @click="openUserInfoPanel">
            <i class="vh-iconfont vh-line-user"></i>
            <p>{{ $t('host.host_1022') }}</p>
          </div>

          <!-- 清晰度选择 -->
          <!-- <div
            v-if="canSetQuality"
            class="header-right_control_wrap-container-setting"
            :class="{ 'header-right_control_wrap-container-disabled': disabledSetQuality }"
            @click="openQualitySetting"
          >
            <i class="vh-saas-iconfont vh-saas-Vector"></i>
            <p>清晰度选择</p>
          </div> -->
        </div>
      </div>
    </div>
    <likeDataSetting ref="virtualLikesDialog"></likeDataSetting>
    <!-- <QualitySetting ref="qualitySettingDialog"></QualitySetting> -->
    <UserInfoSetting ref="userInfoSetting"></UserInfoSetting>
  </div>
</template>
<script>
  import {
    useRoomBaseServer,
    useSplitScreenServer,
    useUserServer,
    useMediaSettingServer
  } from 'middle-domain';
  import { getDefaultAvatar } from '@/app-shared/utils/ossImgConfig';
  import { debounce } from 'lodash';
  export default {
    name: 'HeaderControl',
    components: {
      likeDataSetting: () => import('./likeDataSetting.vue'),
      // QualitySetting: () => import('./QualitySetting.vue')
      UserInfoSetting: () => import('./UserInfoSetting.vue')
    },
    computed: {
      //是不是发起端直播流嵌入
      isEmbedLiveSream() {
        return this.$route.meta.page == 'live-stream';
      },
      // 活动状态（2-预约 1-直播 3-结束 4-点播 5-回放）
      webinarType() {
        return Number(this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.type);
      },
      // 直播模式：1-音频直播、2-视频直播、3-互动直播 6-分组直播 5 定时直播
      webinarMode() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.mode;
      },
      isSupportSplitScreen() {
        return (
          (this.userInfo.role_name == 1 || this.userInfo.role_name == 4) &&
          this.webinarInfo.mode != 6 &&
          this.webinarInfo.mode != 1
        );
      },
      isLiving() {
        //是否正在直播  虚拟人数是否可以使用，只有直播的时候可以使用
        return this.webinarInfo.type == 1;
      },
      configList() {
        return this.$domainStore.state.roomBaseServer.configList;
      },
      // 是否开启分屏
      isOpenSplitScreen() {
        return this.$domainStore.state.splitScreenServer.isOpenSplitScreen;
      },
      // 是否开启了插播
      isInsertFilePushing() {
        return this.$domainStore.state.insertFileServer.isInsertFilePushing;
      },
      // 是否开启桌面共享
      isCurrentShareScreen() {
        return (
          this.$domainStore.state.desktopShareServer.localDesktopStreamId &&
          this.$domainStore.state.desktopShareServer.desktopShareInfo.accountId ==
            this.$domainStore.state.roomBaseServer.watchInitData.join_info.third_party_user_id
        );
      },
      // 是否正在第三方推流
      thirtPushStreamimg() {
        return this.$domainStore.state.roomBaseServer.isThirdStream;
      },
      //是否显示第三方推流组件
      isShowThirdPushStream() {
        // mode == 2: 支持第三方推流 并且不能是无延迟直播， 配置项configList['btn_thirdway'] == 1
        return (
          this.configList['btn_thirdway'] &&
          (this.webinarMode == 2 || this.webinarInfo.no_delay_webinar == 0)
          // &&
          // this.$domainStore.state.roomBaseServer.interactToolStatus.speakerAndShowLayout != 1
        );
      },
      // 媒体设置icon展示
      showSetting() {
        return (
          (this.userInfo.role_name == 1 || this.userInfo.role_name == 4) &&
          // 不是云导播
          !(
            this.$domainStore.state.roomBaseServer.watchInitData.webinar.is_director == 1 &&
            this.$domainStore.state.roomBaseServer.watchInitData.permissionKey[
              'webinar.director'
            ] == 1
          )
        );
      },
      // 是否为云导播活动
      isDirector() {
        return (
          this.$domainStore.state.roomBaseServer.watchInitData.webinar.is_director == 1 &&
          this.$domainStore.state.roomBaseServer.watchInitData.permissionKey['webinar.director'] ==
            1
        );
      },
      defaultAvatar() {
        return getDefaultAvatar();
      },
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      },
      // 是否可以设置清晰度
      // canSetQuality() {
      //   // 开启了设置权限 + 定时直播 + 助理角色 + 不是国都
      //   return (
      //     this.configList['have_push_definition'] &&
      //     this.webinarMode == 5 &&
      //     this.userInfo.role_name == 3 &&
      //     !this.auth_gd
      //   );
      // },
      // 活动开播时间
      webinarStartTime() {
        return (
          this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.start_time || undefined
        );
      },
      // 是否置灰设置清晰度
      disabledSetQuality() {
        // 在[预约、结束、回放]状态下,且开播时间大于当前时间可用，其它状态都置灰
        return !([2, 3, 5].includes(this.webinarType) && dayjs(this.webinarStartTime) > Date.now());
      }
    },
    data() {
      return {
        roomBaseState: null,
        userInfo: {}, // 用户头图和名称、角色
        webinarInfo: {} //活动下信息
      };
    },
    created() {
      this.roomBaseServer = useRoomBaseServer();
      this.splitScreenServer = useSplitScreenServer();
      this.useServer = useUserServer();
      this.roomBaseState = this.roomBaseServer.state;
      this.userInfo = this.roomBaseState.watchInitData.join_info;
      this.webinarInfo = this.roomBaseState.watchInitData.webinar;
    },
    methods: {
      // 分屏状态更改
      handleSplitScreenChange() {
        window.vhallReportForProduct && window.vhallReportForProduct.report(120003);
        if (this.isOpenSplitScreen) {
          this.splitScreenServer.closeSplit();
        } else {
          const layout = useMediaSettingServer().state.layout || sessionStorage.getItem('layout');
          // queryString
          const search = location.search
            ? `${location.search}&s=1&layout=${layout}`
            : `?s=1&layout=${layout}`;
          // location
          const url =
            process.env.NODE_ENV === 'development'
              ? `${window.location.origin}`
              : `${window.location.protocol}${window.domainOfLive()}${
                  process.env.VUE_APP_ROUTER_BASE_URL
                }`;
          const retUrl = `${url}/lives/split-screen/${this.$route.params.id}${search}`;
          this.splitScreenServer.openSplit(retUrl);
        }
      },
      openMediaSettings() {
        // TODO 媒体设置弹窗
        this.$emit('openMediaSettings');
      },
      roleQuit() {
        // 角色退出
        window.vhallReportForProduct && window.vhallReportForProduct.report(110142);
        this.useServer.loginRoleOut({ webinar_id: this.webinarInfo.id }).then(res => {
          if (res.code == 200) {
            let url = `${window.location.protocol}${window.domainOfLive()}${
              process.env.VUE_APP_WEB_KEY
            }/lives/keylogin/${this.webinarInfo.id}/${this.userInfo.role_name}`;
            if (this.auth_gd) {
              url += '?embedSource=gd';
              window.parent.postMessage(
                {
                  type: 'roleLoggedOut',
                  data: {}
                },
                '*'
              );
            }
            window.location.href = url;
            window.localStorage.clear();
            window.sessionStorage.clear();
          }
        });
        // 调用退出接口 跳转页面
      },
      thirdPartySwitch: debounce(
        function (status) {
          if (this.isLiving) {
            this.$message.warning(this.$t('host.host_1021'));
            return;
          }
          if (status) {
            this.thirdPartyShow();
          } else {
            this.thirdPartyClose();
          }
        },
        500,
        {
          // 延迟开始前调用
          leading: true
        }
      ),
      thirdPartyShow() {
        // 第三方发起
        window.vhallReportForProduct && window.vhallReportForProduct.report(120002);
        this.$emit('thirdPushStream', true);
        this.roomBaseServer.setInavToolStatus('start_type', 4);
      },
      thirdPartyClose() {
        // 网页发起 第三方发起关闭
        this.$emit('thirdPushStream', false);
        this.roomBaseServer.setInavToolStatus('start_type', 1);
      },
      openVirtualAudience() {
        // 虚拟人数弹窗
        window.vhallReportForProduct && window.vhallReportForProduct.report(120004);
        this.$emit('openVirtualProple');
      },
      openVirtualLikes() {
        this.$refs.virtualLikesDialog.open();
      },
      openUserInfoPanel: debounce(function () {
        this.$refs.userInfoSetting?.open();
      }, 300)
      // 清晰度选择
      // openQualitySetting: debounce(function () {
      //   if (this.disabledSetQuality || this.isLiving) return;
      //   this.$refs.qualitySettingDialog?.open();
      // }, 300)
    }
  };
</script>
<style lang="less">
  .header-right_control {
    height: 100%;
    &:hover {
      .header-right_control_wrap {
        display: block;
      }
    }
    &_icon {
      border-radius: 50%;
      width: 28px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      color: @font-error-low;
      font-size: 20px;
      cursor: pointer;
      border-radius: 50%;
      // background: url('../img/my-dark@2x.png') no-repeat;
      background-size: 100% 100%;
      // background-color: hsla(0, 0%, 88.6%, 0.15);
    }
    &_wrap {
      display: none;
      min-width: 244px;
      position: absolute;
      top: 35px;
      right: 10px;
      z-index: 10;
      // width: 260px;
      border-radius: 4px;
      overflow: hidden;
      font-size: 14px;
      cursor: auto;
      background: transparent;
      padding-top: 15px;
      &-head {
        height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: @bg-error-light;
        border: 4px 4px 0 0;
        &-left {
          display: flex;
          flex-direction: row;
          align-items: center;

          &-role {
            padding: 3px 8px;
            font-size: 12px;
            border: 1px solid @border-host-color;
            border-radius: 50px;
            text-align: center;
            color: @font-error-low;
            line-height: 1.4;
          }
          &-name {
            min-width: 110px;
            color: @font-error-low;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;
            margin-left: 7px;
            vertical-align: bottom;
          }
        }
        &-right {
          color: @font-error-low;
          cursor: pointer;
          font-size: 14px;
        }
      }
      &-container {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 18px 20px;
        background-color: @bg-light-normal;

        &-setting {
          font-size: 12px;
          color: @font-hover-low;
          cursor: pointer;
          box-sizing: border-box;
          text-align: center;
          padding: 0 3px;
          min-width: 70px;
          i {
            display: inline-block;
            width: 34px;
            height: 34px;
            font-size: 19px;
            color: #888;
            border: 1px solid #888;
            line-height: 34px;
            border-radius: 50%;
          }
          .iconfenpingmoshi {
            font-size: 16px;
          }
          p {
            line-height: 36px;
          }
          &:hover {
            i {
              border: 1px solid @border-light-color;
              color: @font-error-low;
              background-color: @bg-error-light;
            }
            p {
              color: @font-error;
            }
          }
        }
        &-disabled {
          cursor: default;
          color: @font-disabled-normal;
          pointer-events: none;
          i {
            border: 1px solid @border-normal-color;
            color: @border-normal-color;
            background-color: bg-light-normal;
          }
        }
      }
      &-bottom {
        text-align: center;
        height: 32px;
        line-height: 32px;
        background-color: @bg-lighter-normal;
        font-size: 12px;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        &:hover {
          color: #5d6efe;
        }
      }
    }
  }
</style>
